<section
  class="validation-container d-flex flex-column flex-lg-row justify-content-center align-items-center"
>
  @for(option of configOptions; track option.id){
  <button
    class="validation-option rounded-3 border border-1 my-3 d-flex flex-column justify-content-center align-items-center"
    [class.selected]="selectedValidationMethod == option.id"
    (click)="setBiometricValidationMethod(option.id)"
  >
    <icon [icon]="option.icon" size="150" />
    <span class="fs-6 text-uppercase fw-semibold">{{
      option.label | translate
    }}</span>
  </button>
  }
</section>
